export default "__VITE_ASSET__Co3vQxLV__"